import { Box, Avatar, Typography, Divider, List, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import PerfilMenuItem from "./MenuListItem";

const DrawerContent = ({ user, menuItems, desktopOpen, isMobile, location, onMobileClose, onDesktopToggle  }) => (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        {/* Header do Drawer com botão de fechar */}
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: "flex-end", color: 'white', minHeight: '34px', p: 1 }}>
        <IconButton
            onClick={isMobile ? onMobileClose : onDesktopToggle}
            sx={{
            color: 'gray',
            backgroundColor: 'white',
            '&:hover': { backgroundColor: '#f5f5f5' },
            transition: 'background-color 0.2s ease',
            }}
            size="small"
        >
            {isMobile ? <CloseIcon /> : <ChevronLeftIcon />}
        </IconButton>
        </Box>

        {/* Conteúdo do Drawer */}
        {desktopOpen && (
        <>
            <Box sx={{ p: 3, textAlign: "center", color: "white" }}>
                <Avatar
                    src={user?.google_image}
                    alt={user?.name}
                    sx={{ width: 90, height: 90, margin: "0 auto", bgcolor: "#546e7a" }}
                >
                    {user?.name?.[0]?.toUpperCase() || "U"}
                </Avatar>
                <Typography variant="h6" sx={{ mt: 1 }}>{user?.name || "Usuário"}</Typography>
                <Typography variant="body2" color="rgba(255,255,255,0.7)">{user?.email || "email@exemplo.com"}</Typography>
            </Box>
            <Divider sx={{ bgcolor: "rgba(255,255,255,0.2)" }} />
        </>
        )}

        <List sx={{ py: 0 }}>
            {menuItems.map((item) => (
                <PerfilMenuItem
                key={item.title}
                item={item}
                desktopOpen={desktopOpen}
                isMobile={isMobile}
                location={location}
                onClose={onMobileClose}
                />
            ))}
        </List>
    </Box>
);

export default DrawerContent;
